import { ScheduleType } from 'mbs-ui-shared@models/backup/schedule-models';
import { WizardHelpersSettings } from 'wizards/helpers/bases/base-for-steps-helper';
import { PlanDataFromStepsHelper } from 'wizards/helpers/plan-data-from-steps-helper/plan-data-from-steps-helper';
import { RestorePlanFromStepsHelper } from 'wizards/helpers/restore-plan-from-steps-helper/restore-plan-from-steps-helper';
import { RestoreFileFormModel } from 'wizards/models/restoreFile/restore-file-form-model';
import { BaseForPlanHelper } from '../../models/base/base-models/base-for-plan-helper';

export class RestoreFilePlanFromStepsHelpers extends BaseForPlanHelper {
  public static RestorePlanModel: RestoreFileFormModel = null;

  public static getUpdatedPlan(plan, model: RestoreFileFormModel, settings: WizardHelpersSettings): any {
    this.RestorePlanModel = model;
    this.updateSchedules(
      +ScheduleType[model.scheduleStep.ScheduleType] === ScheduleType.recurring,
      this.RestorePlanModel.scheduleAdvancedStep
    );
    const newPlan = Object.assign({}, plan);
    this.updateModel(newPlan, settings);
    return newPlan;
  }

  static updateModel(newPlan, settings: WizardHelpersSettings): void {
    RestorePlanFromStepsHelper.updateNewPlanByNameStep(newPlan, this.RestorePlanModel.planNameStep);
    PlanDataFromStepsHelper.updateNewPlanByWhereBackupStep(newPlan, this.RestorePlanModel.whereBackupStep);
    RestorePlanFromStepsHelper.updateNewPlanByBackupToRestoreStep(newPlan, this.RestorePlanModel.backupToRestoreStep);
    RestorePlanFromStepsHelper.updateNewPlanByRestorePointStep(newPlan, this.RestorePlanModel.restorePointStep, settings);
    RestorePlanFromStepsHelper.updateNewPlanByRestoreSourceStep(
      newPlan,
      this.RestorePlanModel.restoreSourceStep,
      settings.isUnix,
      settings.compName,
      settings.isNBF
    );
    RestorePlanFromStepsHelper.updateNewPlanByDestinationStep(
      newPlan,
      this.RestorePlanModel.destinationStep,
      null,
      false,
      !settings.isUnix || settings.isNBF
    );

    RestorePlanFromStepsHelper.updateNewPlanByEncryptionOptionsStep(newPlan, this.RestorePlanModel.encryptionOptionsStep);
    RestorePlanFromStepsHelper.updateNewPlanByScheduleStep(
      newPlan,
      this.RestorePlanModel.scheduleStep,
      this.RestorePlanModel.scheduleAdvancedStep,
      settings.isUnix,
      settings.isNBF
    );

    // TODO need update for unix then will be ready task: BACKUPMAC-3829
    if (!settings.isUnix) {
      PlanDataFromStepsHelper.updateNewPlanByPrePostActionsStep(
        newPlan,
        this.RestorePlanModel.prePostActionsStep,
        !settings.allowPrePostActions,
        false,
        true
      );
    }

    this.setDataFromRestore(newPlan, settings, this.RestorePlanModel);
    PlanDataFromStepsHelper.updateNewPlanByNotificationStep(newPlan, this.RestorePlanModel.notificationStep);
    PlanDataFromStepsHelper.preparePlanForSending(newPlan);
  }
}
